"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "code": "XUA",
    "name": {
        "en": "XUA - The African Development Bank (ADB) is using a Unit of Account which is registered as XUA as ISO 4217 standard currency code."
    },
    "type": "national",
    "status": "active",
    "exponent": 2,
    "isoNumeric3Code": "965",
    "isoAlpha3Code": "XUA",
    "parentCurrencyMultiplier": 1
};
